import { Card, CardFooter, CounterBadge, Text } from "@fluentui/react-components";
import { useState } from "react";
import { IPromotionProps } from "../../../hooks/types";
import { _blank, recommendationsGlowImagesConstants } from "../../../utility/app-constants";
import { RandomGlowImage } from "../../../utility/app-utilities";
import { Open16Regular } from "@fluentui/react-icons";
/**
 * To display Recommended Carousel Card
 * @param props 
 * @returns 
 */
export default function RecommendedCarouselCard(props: { value: IPromotionProps }) {
    const [glowImage] = useState(RandomGlowImage(recommendationsGlowImagesConstants.glowImage as []));

    return (
        <div className="recommended-card-main">
            <CounterBadge className="recommended-badge" appearance="filled" color="danger" count={1} style={{ display: props?.value?.counterBadge ? "inline" : "none" }} />
            <Card
                className="recommended-card" data-testid="recommendation-card"
                onClick={() => window.open(props?.value?.linkHref, _blank)}
            >
                <div className='recommended-card-content'>
                    <div className='recommended-text-div'>
                        <div className='recommended-text-content'>
                            <p className='recommended-header-text'>{props.value.promotionTitle}</p>
                            {props.value.promotionBody ? (<p className='recommended-body-text'>{props.value.promotionBody}</p>) : null}
                        </div>
                    </div>
                    <div className='recommended-image-main'>
                        <img className="recommended-glow-image" src={glowImage} alt="glow" />
                        {(props.value.imageURL) ? (<img className='recommended-image' width="100%" src={props.value.imageURL} alt={props.value.altText} />) : null}
                    </div>
                </div>

                <CardFooter className="recommended-card-footer" data-testid="recommended-hover">
                    <Text className="card-footer-text">
                        {props.value.callToAction}
                    </Text>
                    <Open16Regular className="recommended-share-img" />
                </CardFooter>
            </Card>
        </div>
    );
}